module.exports = __webpack_public_path__ + "static/media/ufoHit.bb9b0b7d.mp3";